import Immutable from 'immutable';

function indexBy(property, aProcessModel) {
    let processModel = aProcessModel ? aProcessModel : a => a;
    return models =>
        models.reduce((acc, model) => acc.set(model.get(property), processModel(model)), Immutable.OrderedMap());
}

function processProperty(property, updater) {
    return model => model.update(property, updater);
}

function indexPropertyBy(objectProperty, subProperty) {
    return processProperty(objectProperty, indexBy(subProperty));
}

function sortByProperty(property) {
    return model => model.sortBy(item => item.get(property));
}

// aby sme vedeli zobrazovať informácie o rovnakom bete aj ked sa selection zmení
function buildBetId2SelectionIdMap(group) {
    return group.set(
        'betId2SelectionId',
        group.get('picks').reduce((acc, pick) => acc.set(pick.get('betId'), pick.get('selectionId')), Immutable.Map())
    );
}

export function parseBetslip(json) {
    const jsonObj = Immutable.fromJS(json);

    if (jsonObj.get('messageType') === 'PUSH') {
        return jsonObj;
    }

    const nextPollTime =
        jsonObj.getIn(['betslip', 'nextPollInMillis'], null) !== null
            ? new Date(Date.now() + jsonObj.getIn(['betslip', 'nextPollInMillis']))
            : null;
    const betslip = jsonObj
        .get('betslip')
        .update('availableGroups', groups => groups.toOrderedMap())
        // .update('quickBets', groups => groups.toOrderedMap())
        .set('nextPollTime', nextPollTime)
        .update('extrasAvailable', extras => extras.map(v => Immutable.List(v).toOrderedMap()))
        .updateIn(['betslip', 'pickIds'], Immutable.Set)
        .update('groups', groups =>
            groups
                .map(processProperty('picks', indexBy('selectionId', indexPropertyBy('selections', 'selectionId'))))
                .map(
                    processProperty('picks', picks => picks.map(processProperty('selections', sortByProperty('order'))))
                )
                .map(buildBetId2SelectionIdMap)
        );

    return jsonObj
        .updateIn(['currentPickIds'], Immutable.Set)
        .updateIn(['otherPickIds'], Immutable.Set)
        .set('betslip', betslip);
}
